// src/pages/Parametros/tabs/TabRelatorio.jsx
import React from 'react';
import {
    Box, Switch, Typography, Paper, Alert, Divider,
} from '@mui/material';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

const REGRAS = [
    {
        key: 'validarCtMaiorQueEcoli',
        label: 'CT deve ser maior que E. coli',
        description: 'Amostra marcada como inválida se CT ≤ E. coli',
    },
    {
        key: 'validarEficienciaPositiva',
        label: 'Eficiência deve ser positiva (> 0)',
        description: 'Amostra marcada como inválida se eficiência ≤ 0',
    },
    {
        key: 'validarEficienciaMaiorQue20',
        label: 'Eficiência deve ser maior que 20%',
        description: 'Amostra marcada como inválida se eficiência < 20%',
    },
    {
        key: 'marcarAlertaEmInconsistencia',
        label: 'Marcar relatório com alerta em inconsistência de duplicata',
        description: 'Adiciona flag de alerta no PDF quando relação de duplicata > limite',
    },
];

export default function TabRelatorio() {
    const { params, updateGroup } = useParametrosAnalise();
    const r = params.relatorio;
    const set = (field, value) => updateGroup('relatorio', { [field]: value });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 3 }}>
            <Alert severity="info">
                Estas validações são aplicadas antes de fechar o relatório técnico.
                Se qualquer regra ativa falhar, a amostra pode ser marcada como <strong>inválida</strong> no modal de detalhes.
            </Alert>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={1}>
                    Regras de validação final
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {REGRAS.map(({ key, label, description }, i) => (
                        <React.Fragment key={key}>
                            {i > 0 && <Divider />}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    py: 1.5,
                                    gap: 2,
                                }}
                            >
                                <Box>
                                    <Typography variant="body2" fontWeight={500}>
                                        {label}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {description}
                                    </Typography>
                                </Box>
                                <Switch
                                    checked={r[key]}
                                    onChange={(e) => set(key, e.target.checked)}
                                />
                            </Box>
                        </React.Fragment>
                    ))}
                </Box>
            </Paper>
        </Box>
    );
}
